// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { EvaluationTermsPage } from '../pages/EvaluationTermsPage/EvaluationTermsPage';

export const Route = createFileRoute('/evaluation-terms')({
  component: EvaluationTermsPage,
});
